export default __webpack_public_path__ + "static/media/womenShomizTop.c3aeedcf.svg";